import React, { useState, useMemo, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles'; // Import ThemeProvider and createTheme
import { store } from "./Store/store";
import { persistor } from './Store/store';
import { PersistGate } from "redux-persist/integration/react";


import getTheme from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));


function Root({ mode, setMode }) {


  return (
    <Provider store={store}>
      <App />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3500,
          style: {
            background: "var(--mui-palette-background-paper)",
            color: "var(--mui-palette-text-primary)",
            border: "1px solid var(--mui-palette-divider)",
            borderRadius: 0,
            fontFamily: '"Jost", "Helvetica Neue", Arial, sans-serif',
            fontSize: "0.85rem",
            letterSpacing: "0.04em",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
          },
          success: { iconTheme: { primary: "#8A7356", secondary: "#FAF8F5" } },
          error: { iconTheme: { primary: "#B3261E", secondary: "#FAF8F5" } },
        }}
        containerStyle={{ zIndex: 20000 }}
      />
    </Provider>
  );
}

root.render(<Root />);
